import React from "react";
import cx from "classnames";
import { bool, func, node, oneOfType, string } from "prop-types";

import Message from "../../Message";

const propTypes = {
  /** Error state. If vaule is string, it's treated as error message. */
  error: oneOfType([bool, node]),
  /** Help text. */
  help: string,
  /** Legend text. */
  legend: string,
  /** Custom error renderer. Passes props as function parameter. */
  renderError: func,
  /** Custom help renderer. Passes props as function parameter. */
  renderHelp: func,
  /** Custom legend renderer. Passes props as function parameter. */
  renderLegend: func,
};

const RadioCheckGroup = ({
  children,
  className,
  error,
  renderError,
  help,
  renderHelp,
  legend,
  renderLegend,
  ...other
}) => {
  const classes = cx("radiocheck-group", className);

  const formControlClasses = cx("form-control", "form-control--group");

  const groupLegend =
    (renderLegend && renderLegend({ error, legend })) ||
    (legend && (
      <span>
        <legend>{legend}</legend>
      </span>
    ));

  const helpMessage =
    (renderHelp && renderHelp({ help })) ||
    (help && <Message type="help">{help}</Message>);

  const errorMessage =
    (renderError && renderError({ error })) ||
    (error && typeof error === "string" && (
      <Message type="error">{error}</Message>
    ));

  return (
    <div className={formControlClasses}>
      <fieldset className={classes} {...other}>
        {groupLegend}
        {children}
        {helpMessage}
        {errorMessage}
      </fieldset>
    </div>
  );
};

RadioCheckGroup.displayName = "RadioCheckGroup";
RadioCheckGroup.propTypes = propTypes;

export default RadioCheckGroup;
